import styled from 'styled-components'

import { Show, PortalExit, PortalProvider, useContext } from './SideBarPortal'
import { SideBarGroup } from './SideBarGroup'
import { NavButton } from './NavButton'
import { GlobalDatePicker } from './GlobalDatePicker'

const TopSection = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: space-between;
`

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: space-between;
  padding: 0 9px;
  margin-bottom: ${({ isCollapsed }) => (isCollapsed ? '2.25rem' : '0')};
`

export const SideBar = {
  Show,
  PortalProvider,
  PortalExit,
  SideBarGroup,
  TopSection,
  BottomSection,
  NavButton,
  GlobalDatePicker,
  useContext
}
